var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "el-card",
        {
          staticClass: "my-card",
          attrs: { "body-style": { padding: "20px" } },
        },
        [
          _c(
            "div",
            { staticClass: "my-page" },
            [
              _c("img", {
                staticClass: "card-image",
                attrs: { src: _vm.imageUrl, alt: "Paycools" },
              }),
              _c("br"),
              _c("div", { staticClass: "text-wrapper" }, [
                _c("p", { staticClass: "description" }, [
                  _vm._v("Request permission to:"),
                ]),
                _c("p", { staticClass: "description" }, [
                  _vm._v(
                    "• Auto-dedit from your eWallet upon every transaction you make."
                  ),
                ]),
                _c("p", { staticClass: "description" }, [
                  _vm._v(
                    "• It is only used as a test environment simulation. Click the button below to get callback notification:"
                  ),
                ]),
                _c("br"),
              ]),
              _c(
                "el-button",
                {
                  staticStyle: {
                    "background-color": "#3855F1",
                    color: "white !important",
                    padding: "10px 70px",
                    "text-align": "center",
                    "text-decoration": "none",
                    display: "inline-block",
                    "font-size": "16px",
                    "margin-left": "20px",
                    cursor: "pointer",
                    border: "none",
                    "border-radius": "8px",
                    "font-weight": "700",
                  },
                  on: { click: _vm.handleClick },
                },
                [_vm._v(" Authorize Now ")]
              ),
              _c("br"),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }